const accountNavigation = {
    bindHandler() {

        $(document.body).on('click', '.accountoverviewpage__back-button', (evt) => {
            $('.page-header__mobile-nav-wrapper').removeClass('d-none');
            body.addClass("disable-overflow");
        });
    }
};

$(() => {
    if ($('#account-overview-page').length) {
        accountNavigation.bindHandler();
    }
});

export default accountNavigation;
